var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-dropdown"},_vm._l((_vm.actions),function(item,index){return _c('div',{key:index,class:{'nav-dropdown-item': true, 
      'disabled': item.disabled==null ? false : item.disabled},on:{"click":function($event){return item.onClick()}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }